import { keyStore } from "@/components/pitchCorrection/keyStore";
import { calculatePitchMapping } from "@/components/pitchCorrection/pitchKnob/calculatePitchMapping";
import { KeyOption } from "@/types/defs/keyOption";
import { Marker } from "@/types/defs/pitchCorrection/marker";

export const diatonicTranspose =
  (key: KeyOption, circles: Marker[], pitches: number[]) => (steps: number) => {
    const ks = keyStore([])[key];
    const pitchMapping = calculatePitchMapping(ks, circles, pitches);
    const ixs = pitchMapping.map((p) => (p === 0 ? -1 : ks.indexOf(p)));
    const newPitchMapping = ixs.map((ix, i) =>
      ix === -1 ? -1 : ks[ix + steps] - pitchMapping[i]
    );
    const newPitches = pitches.map((p, i) =>
      p === 0 ? 0 : p + newPitchMapping[i]
    );
    return newPitches;
  };
